import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { AssetTerm } from '@asset-terms';
import { TermsAndConditionsBody, TermsAndConditionsEntity } from '@app/entities/terms-and-conditions';
import { AccordionSize, AccordionType } from '@design-system/components/templates/accordion/entities/accordion.types';
import {
  TypographyFontSize, TypographyColor, TypographyFontFamily
} from '@design-system/components/atoms/typography/entities/typography.types';

@Component({
  selector: 'app-auto-detail-howto',
  templateUrl: './auto-detail-howto.component.html',
  styleUrls: ['./auto-detail-howto.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AutoDetailHowtoComponent {

  @Input() show: boolean = true;
  @Input() provider: string;

  public readonly accordionType = AccordionType.Card;
  public readonly accordionSize = AccordionSize.SM;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  constructor() { }

  public toggle(status: boolean = !this.show): void {
    this.show = status;
  }

  get assetTermRent(): TermsAndConditionsEntity {
    const terms = { ...AssetTerm.HOW_RENT } as TermsAndConditionsEntity;
    terms.Body = terms.Body.map((section: TermsAndConditionsBody) => {
      const excludedCompanyCondition = section?.Conditions?.find(
        condition => condition.ExcludedCompanies.includes(this.provider));
      return excludedCompanyCondition ? { ...section, Paragraphs: excludedCompanyCondition.Paragraphs } : section;
    });
    return terms;
  }
  
}
